/* eslint-disable max-len */
import axios from 'axios'
import api, {privateApi} from 'utils/api'

export const getAuthToken = async (payload: any) =>
    await api.post('/cps/v1/realms', payload, {headers: {'content-type': 'application/x-www-form-urlencoded'}})

export const getAuthTokenNew = async (payload: any) =>
    await api.post('/cps/v1/realmsNew', payload, {
        headers: {'content-type': 'application/x-www-form-urlencoded'}
    })

export const getUserInfo = async (token: string) =>
    await api.get('/cps/v1/userinfo', {headers: {Authorization: `Bearer ${token}`}})

export const getUserInfoNew = async (token: string) =>
    await api.get('/cps/v1/userinfoNew', {headers: {Authorization: `Bearer ${token}`}})

export const getLoginDetails = async (payload: any) =>
    await api.post('/cps/v1/auth', {newLogin: payload.newLogin}, {headers: payload.headers})

export const getLoginAttemptsDetails = async (userID: string) => {
    const payload = {username: userID}
    const {data} = await api.post('/cps/v1/loginAttempts', payload)
    return data
}

export const getRefreshToken = async (payload: any) =>
    await api.post('/cps/v1/refresh', payload, {headers: {'content-type': 'application/x-www-form-urlencoded'}})

export const invalidateToken = async (payload: any) =>
    await api.post('/cps/v1/invalidate', payload, {
        headers: {'content-type': 'application/x-www-form-urlencoded'}
    })

export const sessionRefreshListener = async (param: any) =>
    await api.get(`/cps/v1/sessionRefresh?logout=${param}`, {
        headers: {
            Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7'
        }
    })

export const signonFilter = async (token: any) => await api.get(`/lmsweb/flight_status.jsp?reacttoken=${token}`)

export const updateQuickLinks = async (payload: any) => await privateApi.post('cps/v1/update-quicklinks', payload)

export const getNotificationMessages = async (payload: any, token: any) =>
    await api.post('/cps/v1/getnotificationmessages', payload, {headers: {Authorization: `Bearer ${token}`}})

export const deactivateNotificationMessage = async (payload: any) =>
    await api.post('/cps/v1/deactivate-notification-messages', payload)

export const UpdateLogout = async (payload: any) =>
    await api.post('cps/v1/update-logout', {
        newLogin: payload.newLogin,
        logout: payload.logout,
        userId: payload.userId
    })

export const getMenuItemJson = async (fileName: any) => {
    const response = await axios.get(`/lmsweb/assets/jsons/${fileName}.json`, {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0'
        }
    })
    return response.data
}

export const publicToken = async (payload: any) =>
    await axios.post('/cps/v1/realmsNew', payload, {
        headers: {'content-type': 'application/x-www-form-urlencoded'}
    })
